/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getPreparedForm = /* GraphQL */ `query GetPreparedForm($id: ID!) {
  getPreparedForm(id: $id) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    companyID
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    relativeAdmins
    state
    preparerID
    preparer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    templateID
    template {
      id
      name
      processes
      archived
      updatedAt
      requiresAttorneyApproval
      requiresSponsorApproval
      requiresNationalApproval
      employersCanView
      nationalsCanView
      __typename
    }
    completedFormID
    completedForm {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    completedFormHistory {
      nextToken
      __typename
    }
    assignedToID
    assignedToEmployerID
    assignedToNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    rejectedDate
    rejectedByID
    rejectedByEmployerID
    rejectedByNationalID
    rejectedByTeamMemberID
    rejectedByEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    rejectedByNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    rejectedByTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    requiresAttorneyApproval
    attorneyApproverID
    attorneyApprover {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    attorneyApprovalDate
    requiresSponsorApproval
    sponsorApproverID
    sponsorApproverEmployerID
    sponsorApproverNationalID
    sponsorApproverEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    sponsorApproverNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    sponsorApprovalDate
    requiresNationalApproval
    nationalApproverID
    nationalApprover {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    nationalApprovalDate
    finalCaseManagerApproverID
    finalCaseManagerApprover {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    finalCaseManagerApprovalDate
    employersCanView
    nationalsCanView
    createdAt
    updatedAt
    comments {
      nextToken
      __typename
    }
    activities {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPreparedFormQueryVariables,
  APITypes.GetPreparedFormQuery
>;
export const listPreparedForms = /* GraphQL */ `query ListPreparedForms(
  $filter: ModelPreparedFormFilterInput
  $limit: Int
  $nextToken: String
) {
  listPreparedForms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      caseID
      companyID
      foreignNationalID
      relativeAdmins
      state
      preparerID
      templateID
      completedFormID
      assignedToID
      assignedToEmployerID
      assignedToNationalID
      assignedToTeamMemberID
      rejectedDate
      rejectedByID
      rejectedByEmployerID
      rejectedByNationalID
      rejectedByTeamMemberID
      requiresAttorneyApproval
      attorneyApproverID
      attorneyApprovalDate
      requiresSponsorApproval
      sponsorApproverID
      sponsorApproverEmployerID
      sponsorApproverNationalID
      sponsorApprovalDate
      requiresNationalApproval
      nationalApproverID
      nationalApprovalDate
      finalCaseManagerApproverID
      finalCaseManagerApprovalDate
      employersCanView
      nationalsCanView
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPreparedFormsQueryVariables,
  APITypes.ListPreparedFormsQuery
>;
export const getForeignNational = /* GraphQL */ `query GetForeignNational($id: ID!) {
  getForeignNational(id: $id) {
    type
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    onboardingSections {
      background
      contact
      employment
      family
      immigration
      personal
      __typename
    }
    completedOnboardingQuestionsBy
    email
    emailPersonal
    emailWork
    usMailingAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    usResidentialAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    lastAddressOutsideUS {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    nickname
    employeeId
    additionalFirstnames
    additionalMiddlenames
    additionalLastnames
    lowerFirst
    lowerLast
    lowerFull
    maritalStatus
    spouse
    dependents
    phone
    phoneWork
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    companyNationalNumber
    mostRecentlyInvited
    archived
    workLocation {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    relativesAsSource {
      nextToken
      __typename
    }
    relativesAsTarget {
      nextToken
      __typename
    }
    relatives
    relativeAdmins
    immigrationStatus {
      status
      doesNotExpire
      expiration
      __typename
    }
    immigrationVisaStatus
    visaExpiration
    nonImmigrantVisaNumber
    visaIssueDate
    visaConsulate
    immigrantVisaApplicant
    immigrantPetitionEverFiled
    j1j2 {
      hasHad
      start
      end
      __typename
    }
    hasHadI485Filed {
      value
      followPrompt
      followValue
      __typename
    }
    hasPendingETA9089
    hasApprovedI140 {
      hasApproved
      classification
      employmentBasedCategory
      priorityDate
      petitionerI140
      __typename
    }
    aosFilingEligible
    hasValidOrExpiredEAD
    hasPendingUSCISApplication
    hasHadVisaPetitionRevokedOrDenied
    hasBeenArrestedSinceLastUSEntry
    criminalHistory {
      tortureGenocide
      killing
      severeInjuring
      nonconsensualSex
      religiousBelief
      __typename
    }
    hasTransportedWeapons
    hasParticipatedInArmedGroup
    hasDetailedPerson
    hasUsedWeapons
    hasWeaponsTraining
    hasCriminalOffence
    hasViolatedVisaTerms
    isInRemovalProceedings {
      value
      reason
      __typename
    }
    hasBeenEmployedSinceLastAdmitted {
      value
      reason
      __typename
    }
    citizenshipCountry
    birthCountry
    birthState
    birthDate
    birthCity
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    nivMaxout
    offeredSalary {
      currency
      amount
      period
      __typename
    }
    isRemote
    loginStatus {
      isEnabled
      status
      __typename
    }
    hasNonUSPassport
    passportGender
    passportIssueDate
    passportExpirationDate
    passportExpirationReminderSentForDate
    passportNumber
    passportCountry
    usSSN
    hasSSN
    aNumber
    lastEntryUS
    i94ArrivalDepartureRecordNumber
    sevisNumber
    eadNumber
    cases {
      nextToken
      __typename
    }
    sponsoredCases {
      nextToken
      __typename
    }
    processRequests {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    files {
      nextToken
      __typename
    }
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    fileRequirementsManipulated
    test
    notes
    companyName
    immigrationCurrentStatus
    immigrationStatusExpiration
    employmentBasedCategory
    priorityDate
    eadExpDate
    I797ExpDate
    visaExpDate
    reportEntries {
      nextToken
      __typename
    }
    chargeabilityCountry
    birthCountryCode
    socCode
    firstEntryUS
    taxTrackingF1J1
    citizenshipEligibilityDate
    startDate
    legalTeamIDs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetForeignNationalQueryVariables,
  APITypes.GetForeignNationalQuery
>;
export const listForeignNationals = /* GraphQL */ `query ListForeignNationals(
  $filter: ModelForeignNationalFilterInput
  $limit: Int
  $nextToken: String
) {
  listForeignNationals(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListForeignNationalsQueryVariables,
  APITypes.ListForeignNationalsQuery
>;
export const nationalsBySlug = /* GraphQL */ `query NationalsBySlug(
  $slug: String!
  $sortDirection: ModelSortDirection
  $filter: ModelForeignNationalFilterInput
  $limit: Int
  $nextToken: String
) {
  nationalsBySlug(
    slug: $slug
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NationalsBySlugQueryVariables,
  APITypes.NationalsBySlugQuery
>;
export const nationalsByEmail = /* GraphQL */ `query NationalsByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelForeignNationalFilterInput
  $limit: Int
  $nextToken: String
) {
  nationalsByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NationalsByEmailQueryVariables,
  APITypes.NationalsByEmailQuery
>;
export const searchForeignNationals = /* GraphQL */ `query SearchForeignNationals(
  $filter: SearchableForeignNationalFilterInput
  $sort: [SearchableForeignNationalSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableForeignNationalAggregationInput]
) {
  searchForeignNationals(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchForeignNationalsQueryVariables,
  APITypes.SearchForeignNationalsQuery
>;
export const getEmployer = /* GraphQL */ `query GetEmployer($id: ID!) {
  getEmployer(id: $id) {
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    type
    email
    personalEmail
    newsletterModalViewCount
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    lowerFirst
    lowerLast
    lowerFull
    address
    phone
    personalPhone
    title
    companyIDs
    companies {
      nextToken
      __typename
    }
    adminCompanies {
      nextToken
      __typename
    }
    invoicingContactCompanies {
      nextToken
      __typename
    }
    primaryContactCompanies {
      nextToken
      __typename
    }
    seniorContactCompanies {
      nextToken
      __typename
    }
    signatoryContactCompanies {
      nextToken
      __typename
    }
    sponsoredCases {
      nextToken
      __typename
    }
    contributorCases {
      nextToken
      __typename
    }
    processRequestAssignments {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    hasCompletedOnboardingQuestions
    recentlyViewedCases
    mostRecentlyInvited
    archived
    loginStatus {
      isEnabled
      status
      __typename
    }
    customTemplates {
      nextToken
      __typename
    }
    invoicingContactCompanyIDs
    isInvoicingContact
    primaryContactCompanyIDs
    isPrimaryContact
    seniorContactCompanyIDs
    isSeniorContact
    signatoryContactCompanyIDs
    isSignatoryContact
    assignedCaseIDs
    nationalsWithOpenCases
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEmployerQueryVariables,
  APITypes.GetEmployerQuery
>;
export const listEmployers = /* GraphQL */ `query ListEmployers(
  $filter: ModelEmployerFilterInput
  $limit: Int
  $nextToken: String
) {
  listEmployers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEmployersQueryVariables,
  APITypes.ListEmployersQuery
>;
export const employersBySlug = /* GraphQL */ `query EmployersBySlug(
  $slug: String!
  $sortDirection: ModelSortDirection
  $filter: ModelEmployerFilterInput
  $limit: Int
  $nextToken: String
) {
  employersBySlug(
    slug: $slug
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EmployersBySlugQueryVariables,
  APITypes.EmployersBySlugQuery
>;
export const employersByEmail = /* GraphQL */ `query EmployersByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelEmployerFilterInput
  $limit: Int
  $nextToken: String
) {
  employersByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EmployersByEmailQueryVariables,
  APITypes.EmployersByEmailQuery
>;
export const searchEmployers = /* GraphQL */ `query SearchEmployers(
  $filter: SearchableEmployerFilterInput
  $sort: [SearchableEmployerSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableEmployerAggregationInput]
) {
  searchEmployers(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchEmployersQueryVariables,
  APITypes.SearchEmployersQuery
>;
export const getTeamMember = /* GraphQL */ `query GetTeamMember($id: ID!) {
  getTeamMember(id: $id) {
    id
    createdBy
    slug
    userAgreementAcknowledged
    userAgreementAcknowledgementDate
    userAgreementAcknowledgementText
    hasLoggedIn
    type
    email
    username
    avatar {
      version
      __typename
    }
    firstname
    middlename
    lastname
    lowerFirst
    lowerLast
    lowerFull
    phone
    position
    title
    licensingAuthority
    stateBarNumber
    isAdmin
    manager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    managerID
    attorneyAssignments {
      nextToken
      __typename
    }
    paralegalAssignments {
      nextToken
      __typename
    }
    accountManagerAssignments {
      nextToken
      __typename
    }
    attorneyCases {
      nextToken
      __typename
    }
    caseManagerCases {
      nextToken
      __typename
    }
    contributorCases {
      nextToken
      __typename
    }
    processRequestAssignments {
      nextToken
      __typename
    }
    tasks {
      nextToken
      __typename
    }
    mostRecentlyInvited
    archived
    loginStatus {
      isEnabled
      status
      __typename
    }
    recentlyViewedCases
    customTemplates {
      nextToken
      __typename
    }
    nationalsWithOpenCases
    companiesAssignedTo
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTeamMemberQueryVariables,
  APITypes.GetTeamMemberQuery
>;
export const listTeamMembers = /* GraphQL */ `query ListTeamMembers(
  $filter: ModelTeamMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  listTeamMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTeamMembersQueryVariables,
  APITypes.ListTeamMembersQuery
>;
export const teamBySlug = /* GraphQL */ `query TeamBySlug(
  $slug: String!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  teamBySlug(
    slug: $slug
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TeamBySlugQueryVariables,
  APITypes.TeamBySlugQuery
>;
export const listTeamMembersAlpha = /* GraphQL */ `query ListTeamMembersAlpha(
  $type: PersonType!
  $archivedLowerFull: ModelTeamMemberAlphaCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTeamMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  listTeamMembersAlpha(
    type: $type
    archivedLowerFull: $archivedLowerFull
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTeamMembersAlphaQueryVariables,
  APITypes.ListTeamMembersAlphaQuery
>;
export const teamByEmail = /* GraphQL */ `query TeamByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelTeamMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  teamByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TeamByEmailQueryVariables,
  APITypes.TeamByEmailQuery
>;
export const listTeamMembersByPosition = /* GraphQL */ `query ListTeamMembersByPosition(
  $position: Position!
  $archivedLowerFull: ModelTeamMemberByPositionCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTeamMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  listTeamMembersByPosition(
    position: $position
    archivedLowerFull: $archivedLowerFull
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTeamMembersByPositionQueryVariables,
  APITypes.ListTeamMembersByPositionQuery
>;
export const searchTeamMembers = /* GraphQL */ `query SearchTeamMembers(
  $filter: SearchableTeamMemberFilterInput
  $sort: [SearchableTeamMemberSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableTeamMemberAggregationInput]
) {
  searchTeamMembers(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchTeamMembersQueryVariables,
  APITypes.SearchTeamMembersQuery
>;
export const getAttorneyAssignment = /* GraphQL */ `query GetAttorneyAssignment($id: ID!) {
  getAttorneyAssignment(id: $id) {
    id
    companyID
    attorneyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    attorney {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAttorneyAssignmentQueryVariables,
  APITypes.GetAttorneyAssignmentQuery
>;
export const listAttorneyAssignments = /* GraphQL */ `query ListAttorneyAssignments(
  $filter: ModelAttorneyAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAttorneyAssignments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyID
      attorneyID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAttorneyAssignmentsQueryVariables,
  APITypes.ListAttorneyAssignmentsQuery
>;
export const getParalegalAssignment = /* GraphQL */ `query GetParalegalAssignment($id: ID!) {
  getParalegalAssignment(id: $id) {
    id
    companyID
    paralegalID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    paralegal {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetParalegalAssignmentQueryVariables,
  APITypes.GetParalegalAssignmentQuery
>;
export const listParalegalAssignments = /* GraphQL */ `query ListParalegalAssignments(
  $filter: ModelParalegalAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listParalegalAssignments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyID
      paralegalID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListParalegalAssignmentsQueryVariables,
  APITypes.ListParalegalAssignmentsQuery
>;
export const getEmployerAssignment = /* GraphQL */ `query GetEmployerAssignment($id: ID!) {
  getEmployerAssignment(id: $id) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEmployerAssignmentQueryVariables,
  APITypes.GetEmployerAssignmentQuery
>;
export const listEmployerAssignments = /* GraphQL */ `query ListEmployerAssignments(
  $filter: ModelEmployerAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listEmployerAssignments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyID
      employerID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEmployerAssignmentsQueryVariables,
  APITypes.ListEmployerAssignmentsQuery
>;
export const getEmployerAdminAssignment = /* GraphQL */ `query GetEmployerAdminAssignment($id: ID!) {
  getEmployerAdminAssignment(id: $id) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEmployerAdminAssignmentQueryVariables,
  APITypes.GetEmployerAdminAssignmentQuery
>;
export const listEmployerAdminAssignments = /* GraphQL */ `query ListEmployerAdminAssignments(
  $filter: ModelEmployerAdminAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listEmployerAdminAssignments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyID
      employerID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEmployerAdminAssignmentsQueryVariables,
  APITypes.ListEmployerAdminAssignmentsQuery
>;
export const getPrimaryContact = /* GraphQL */ `query GetPrimaryContact($id: ID!) {
  getPrimaryContact(id: $id) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrimaryContactQueryVariables,
  APITypes.GetPrimaryContactQuery
>;
export const listPrimaryContacts = /* GraphQL */ `query ListPrimaryContacts(
  $filter: ModelPrimaryContactFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrimaryContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyID
      employerID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrimaryContactsQueryVariables,
  APITypes.ListPrimaryContactsQuery
>;
export const getSeniorContact = /* GraphQL */ `query GetSeniorContact($id: ID!) {
  getSeniorContact(id: $id) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSeniorContactQueryVariables,
  APITypes.GetSeniorContactQuery
>;
export const listSeniorContacts = /* GraphQL */ `query ListSeniorContacts(
  $filter: ModelSeniorContactFilterInput
  $limit: Int
  $nextToken: String
) {
  listSeniorContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyID
      employerID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSeniorContactsQueryVariables,
  APITypes.ListSeniorContactsQuery
>;
export const getInvoicingContact = /* GraphQL */ `query GetInvoicingContact($id: ID!) {
  getInvoicingContact(id: $id) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvoicingContactQueryVariables,
  APITypes.GetInvoicingContactQuery
>;
export const listInvoicingContacts = /* GraphQL */ `query ListInvoicingContacts(
  $filter: ModelInvoicingContactFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvoicingContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyID
      employerID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoicingContactsQueryVariables,
  APITypes.ListInvoicingContactsQuery
>;
export const getSignatoryContact = /* GraphQL */ `query GetSignatoryContact($id: ID!) {
  getSignatoryContact(id: $id) {
    id
    companyID
    employerID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSignatoryContactQueryVariables,
  APITypes.GetSignatoryContactQuery
>;
export const listSignatoryContacts = /* GraphQL */ `query ListSignatoryContacts(
  $filter: ModelSignatoryContactFilterInput
  $limit: Int
  $nextToken: String
) {
  listSignatoryContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyID
      employerID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSignatoryContactsQueryVariables,
  APITypes.ListSignatoryContactsQuery
>;
export const getCompany = /* GraphQL */ `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    lowerName
    lowerNameKey
    displayCompanyName
    slug
    type
    logo {
      version
      __typename
    }
    domainWhitelist
    onboardingSections {
      companyInfo
      contactInfo
      companyPreferences
      immigrationPreferences
      paymentPreferences
      questions
      employeeInformation
      __typename
    }
    hasCompletedOnboardingQuestions
    completedOnboardingQuestionsBy
    isPartnerCompany
    isParent
    children {
      nextToken
      __typename
    }
    parent {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    parentID
    archived
    companyNumber
    nationalCount
    foreignNationals {
      nextToken
      __typename
    }
    assignedAttorneys {
      nextToken
      __typename
    }
    assignedParalegals {
      nextToken
      __typename
    }
    accountManagerID
    accountManager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    assignedEmployers {
      nextToken
      __typename
    }
    assignedEmployerAdmins {
      nextToken
      __typename
    }
    invoicingContacts {
      nextToken
      __typename
    }
    primaryContacts {
      nextToken
      __typename
    }
    seniorContacts {
      nextToken
      __typename
    }
    signatoryContacts {
      nextToken
      __typename
    }
    data {
      id
      companyID
      preferredMailingAddress
      companyNameShowToFN
      companyCoversExpenseOfDependentPetitionsAndOrEADCards
      doingBusinessAs
      educationEvaluation
      employeesEmailMHAttorneysAndParalegalsDirectly
      fein
      fullTimeEmployeesInUS
      isH1BDependentEmloyer
      hasBeenWillfulViolator
      isHigherEd_20_USC_1001_a
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4
      maintainsAWrittenImmigrationPolicy
      naicsCodeOfCompany
      partTimeEmployeesInUS
      paymentPreference
      permissionPowerAttorney
      permissionReleaseApprovalNotices
      permissionReleasePetitionsRFE
      permissionReleaseLCA
      permissionRelease9089
      phone
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime
      fax
      preferredShippingSpeedForDocuments
      shipOriginalApprovalNotices
      staffsEmployeesAtThirdPartyEndClientSites
      typeOfBusiness
      usesWageSurvey
      usesEVerify
      utilizePremiumProcessingService
      technologyReleaseLicenseRequirement
      yearCompanyWasFoundedInUS
      I9_audit_has_been_completed_in_past_18_months
      current_number_of_H1B_employees
      current_number_of_employees_on_L_visas
      other_visa_statuses_sponsored
      email_address_invoices_should_be_addressed_to
      name_invoices_should_be_addressed_to
      companyCoversExpenseOfDependentPetitions
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime
      annualMeetingDate
      requiresMeetingReminder
      createdAt
      updatedAt
      __typename
    }
    processRequests {
      nextToken
      __typename
    }
    jobDescriptions {
      nextToken
      __typename
    }
    files {
      nextToken
      __typename
    }
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    cases {
      nextToken
      __typename
    }
    openCaseCount
    closedCaseCount
    completedCaseCount
    legalTeamIDs
    notes
    petitionerParagraph
    reportEntries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    companyDataId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyQueryVariables,
  APITypes.GetCompanyQuery
>;
export const listCompanies = /* GraphQL */ `query ListCompanies(
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompaniesQueryVariables,
  APITypes.ListCompaniesQuery
>;
export const companiesBySlug = /* GraphQL */ `query CompaniesBySlug(
  $slug: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  companiesBySlug(
    slug: $slug
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CompaniesBySlugQueryVariables,
  APITypes.CompaniesBySlugQuery
>;
export const listCompaniesAlpha = /* GraphQL */ `query ListCompaniesAlpha(
  $type: CompanyType!
  $archivedLowerNameKey: ModelCompanyAlphaCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompaniesAlpha(
    type: $type
    archivedLowerNameKey: $archivedLowerNameKey
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompaniesAlphaQueryVariables,
  APITypes.ListCompaniesAlphaQuery
>;
export const companiesByParent = /* GraphQL */ `query CompaniesByParent(
  $parentID: ID!
  $archivedLowerNameKey: ModelCompanyCompaniesByParentCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  companiesByParent(
    parentID: $parentID
    archivedLowerNameKey: $archivedLowerNameKey
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CompaniesByParentQueryVariables,
  APITypes.CompaniesByParentQuery
>;
export const searchCompanies = /* GraphQL */ `query SearchCompanies(
  $filter: SearchableCompanyFilterInput
  $sort: [SearchableCompanySortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableCompanyAggregationInput]
) {
  searchCompanies(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchCompaniesQueryVariables,
  APITypes.SearchCompaniesQuery
>;
export const getFirm = /* GraphQL */ `query GetFirm($id: ID!) {
  getFirm(id: $id) {
    id
    name
    slug
    logo {
      version
      __typename
    }
    domainWhitelist
    address {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    mailingAddress {
      careOf
      address
      companyAddressType
      unitNumber
      unitType
      adminArea
      state
      city
      country
      postalCode
      title
      __typename
    }
    doingBusinessAs
    phone
    fax
    knowledgeCenterLinks {
      id
      text
      roles
      __typename
    }
    shortcuts {
      id
      text
      link
      roles
      __typename
    }
    holidays
    companyCount
    nationalCount
    preparedFormTemplates {
      id
      name
      processes
      archived
      updatedAt
      requiresAttorneyApproval
      requiresSponsorApproval
      requiresNationalApproval
      employersCanView
      nationalsCanView
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetFirmQueryVariables, APITypes.GetFirmQuery>;
export const listFirms = /* GraphQL */ `query ListFirms(
  $filter: ModelFirmFilterInput
  $limit: Int
  $nextToken: String
) {
  listFirms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      slug
      domainWhitelist
      doingBusinessAs
      phone
      fax
      holidays
      companyCount
      nationalCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListFirmsQueryVariables, APITypes.ListFirmsQuery>;
export const getJobDescription = /* GraphQL */ `query GetJobDescription($id: ID!) {
  getJobDescription(id: $id) {
    companyID
    id
    archived
    type
    foreignNationalID
    title
    officialTitle
    degrees
    requiresBachelors
    requiresMasters
    requiresPhd
    dotNumber
    caseSocCode
    duties
    jobURL
    majors
    specialRequirements
    yearsGeneralExperience
    objectiveSkillSetsRequired
    offeredSalary
    certificationLicenses
    travelIsRequired
    travelPercentage
    travelDomestic
    travelInternational
    supervisesOthers
    supervisesOthersCount
    supervisesTitles
    supervisorTitle
    canWorkFromHome
    uploadedDescriptionID
    uploadedDescription {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetJobDescriptionQueryVariables,
  APITypes.GetJobDescriptionQuery
>;
export const listJobDescriptions = /* GraphQL */ `query ListJobDescriptions(
  $filter: ModelJobDescriptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listJobDescriptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListJobDescriptionsQueryVariables,
  APITypes.ListJobDescriptionsQuery
>;
export const jobsByCompanyTitle = /* GraphQL */ `query JobsByCompanyTitle(
  $companyID: ID!
  $title: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelJobDescriptionFilterInput
  $limit: Int
  $nextToken: String
) {
  jobsByCompanyTitle(
    companyID: $companyID
    title: $title
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.JobsByCompanyTitleQueryVariables,
  APITypes.JobsByCompanyTitleQuery
>;
export const jobsByCompany = /* GraphQL */ `query JobsByCompany(
  $companyID: ID!
  $archivedType: ModelJobDescriptionByCompanyCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelJobDescriptionFilterInput
  $limit: Int
  $nextToken: String
) {
  jobsByCompany(
    companyID: $companyID
    archivedType: $archivedType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.JobsByCompanyQueryVariables,
  APITypes.JobsByCompanyQuery
>;
export const listJobsByForeignNational = /* GraphQL */ `query ListJobsByForeignNational(
  $foreignNationalID: ID!
  $archivedType: ModelJobDescriptionByForeignNationalCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelJobDescriptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listJobsByForeignNational(
    foreignNationalID: $foreignNationalID
    archivedType: $archivedType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListJobsByForeignNationalQueryVariables,
  APITypes.ListJobsByForeignNationalQuery
>;
export const getProcessRequest = /* GraphQL */ `query GetProcessRequest($id: ID!) {
  getProcessRequest(id: $id) {
    id
    assignedToID
    assignedToEmployerID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseNotes {
      nextToken
      __typename
    }
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    files {
      nextToken
      __typename
    }
    individualSponsored
    initiatorID
    initiator {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    requesterID
    requester {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    requestDate
    approvalDate
    archivedDate
    cancelDate
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    employeeData {
      firstname
      lastname
      middlename
      email
      employeeId
      tempID
      spouse
      dependents
      __typename
    }
    employmentData {
      premiumProcessing
      startDate
      notes
      __typename
    }
    needsEmployerRevision
    resume {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    resumeID
    requestedProcess
    requestedProcessSubCategory
    requestedProcessAdditionalProcessing
    globalRequestedProcessSubCategory
    globalProcessCountryCode
    globalProcessDuration
    globalVisaType
    vendorID
    vendor {
      id
      name
      type
      location
      email
      lowerName
      updatedAt
      createdAt
      __typename
    }
    slug
    state
    lowerNationalName
    lowerCompanyName
    lowerProcessType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProcessRequestQueryVariables,
  APITypes.GetProcessRequestQuery
>;
export const processBySlug = /* GraphQL */ `query ProcessBySlug(
  $slug: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProcessRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  processBySlug(
    slug: $slug
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProcessBySlugQueryVariables,
  APITypes.ProcessBySlugQuery
>;
export const listProcessesByState = /* GraphQL */ `query ListProcessesByState(
  $state: ProcessRequestState!
  $requestDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProcessRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  listProcessesByState(
    state: $state
    requestDate: $requestDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProcessesByStateQueryVariables,
  APITypes.ListProcessesByStateQuery
>;
export const searchProcessRequests = /* GraphQL */ `query SearchProcessRequests(
  $filter: SearchableProcessRequestFilterInput
  $sort: [SearchableProcessRequestSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableProcessRequestAggregationInput]
) {
  searchProcessRequests(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchProcessRequestsQueryVariables,
  APITypes.SearchProcessRequestsQuery
>;
export const getCase = /* GraphQL */ `query GetCase($id: ID!) {
  getCase(id: $id) {
    id
    caseNumber
    slug
    attorneyID
    attorney {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseManagerID
    caseManager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    complianceListID
    complianceList {
      id
      caseID
      educationEvaluationNeeded
      stemExtEligible
      capGap
      wageIssues
      createdAt
      updatedAt
      __typename
    }
    PERMFilingDataID
    PERMFilingData {
      id
      caseID
      PERMFirstPossibleFilingDate
      PERMLastPossibleFilingDate
      applicantsReceived
      createdAt
      updatedAt
      __typename
    }
    caseNotes {
      nextToken
      __typename
    }
    pinnedCaseNoteID
    contributorIds
    contributors {
      nextToken
      __typename
    }
    sponsoringEmployerID
    sponsoringEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    sponsoringNationalID
    sponsoringNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    welcomeLetterAcknowledged
    welcomeLetterAcknowledgementDate
    welcomeLetterAcknowledgedBy
    welcomeLetterText
    nationalVisaExpiration
    relativeAdmins
    startDate
    closeDate
    closeReason
    completeDate
    sourceID
    source {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    state
    tasks {
      nextToken
      __typename
    }
    lowerNationalName
    lowerCompanyName
    lowerProcessType
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    currentPhase
    phaseRequirements {
      phase
      milestones
      __typename
    }
    completedMilestones {
      completionDate
      completedByID
      milestone
      receiptNumber
      __typename
    }
    files {
      nextToken
      __typename
    }
    preparedForms {
      nextToken
      __typename
    }
    prevailingWageCaseNumber
    USCISReceiptNumber
    USCISReceiptDetails {
      nextToken
      __typename
    }
    AOSReceiptNotice
    I485JReceiptNotice
    SelectionNoticeNo
    ETACaseNumber
    shipmentTracking {
      id
      item
      date
      trackingNumber
      provider
      __typename
    }
    isShipmentTrackingElectronically
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    individualSponsored
    jobDescriptionID
    jobDescription {
      companyID
      id
      archived
      type
      foreignNationalID
      title
      officialTitle
      degrees
      requiresBachelors
      requiresMasters
      requiresPhd
      dotNumber
      caseSocCode
      duties
      jobURL
      majors
      specialRequirements
      yearsGeneralExperience
      objectiveSkillSetsRequired
      offeredSalary
      certificationLicenses
      travelIsRequired
      travelPercentage
      travelDomestic
      travelInternational
      supervisesOthers
      supervisesOthersCount
      supervisesTitles
      supervisorTitle
      canWorkFromHome
      uploadedDescriptionID
      createdAt
      updatedAt
      __typename
    }
    employeeData {
      firstname
      lastname
      middlename
      email
      employeeId
      tempID
      spouse
      dependents
      __typename
    }
    employmentData {
      premiumProcessing
      startDate
      notes
      __typename
    }
    resumeID
    resume {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    requestedProcess
    requestedProcessSubCategory
    requestedProcessAdditionalProcessing
    globalRequestedProcessSubCategory
    globalProcessCountryCode
    globalProcessDuration
    globalVisaType
    vendorID
    additionalFieldID
    additionalFields {
      id
      caseID
      fields
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCaseQueryVariables, APITypes.GetCaseQuery>;
export const listCases = /* GraphQL */ `query ListCases(
  $filter: ModelCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  listCases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListCasesQueryVariables, APITypes.ListCasesQuery>;
export const caseBySlug = /* GraphQL */ `query CaseBySlug(
  $slug: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  caseBySlug(
    slug: $slug
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CaseBySlugQueryVariables,
  APITypes.CaseBySlugQuery
>;
export const searchCases = /* GraphQL */ `query SearchCases(
  $filter: SearchableCaseFilterInput
  $sort: [SearchableCaseSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableCaseAggregationInput]
) {
  searchCases(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchCasesQueryVariables,
  APITypes.SearchCasesQuery
>;
export const getUSCISReceiptDetails = /* GraphQL */ `query GetUSCISReceiptDetails($id: ID!) {
  getUSCISReceiptDetails(id: $id) {
    id
    caseID
    receiptType
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    receiptNumber
    formType
    submittedDate
    modifiedDate
    currentCaseStatusText
    currentCaseStatusDesc
    histCaseStatus {
      date
      completedText
      __typename
    }
    message
    isActive
    isLatest
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUSCISReceiptDetailsQueryVariables,
  APITypes.GetUSCISReceiptDetailsQuery
>;
export const listUSCISReceiptDetails = /* GraphQL */ `query ListUSCISReceiptDetails(
  $filter: ModelUSCISReceiptDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listUSCISReceiptDetails(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      caseID
      receiptType
      receiptNumber
      formType
      submittedDate
      modifiedDate
      currentCaseStatusText
      currentCaseStatusDesc
      message
      isActive
      isLatest
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUSCISReceiptDetailsQueryVariables,
  APITypes.ListUSCISReceiptDetailsQuery
>;
export const listCaseComplianceList = /* GraphQL */ `query ListCaseComplianceList(
  $filter: ModelCaseComplianceListFilterInput
  $limit: Int
  $nextToken: String
) {
  listCaseComplianceList(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      caseID
      educationEvaluationNeeded
      stemExtEligible
      capGap
      wageIssues
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCaseComplianceListQueryVariables,
  APITypes.ListCaseComplianceListQuery
>;
export const listPERMFilingData = /* GraphQL */ `query ListPERMFilingData(
  $filter: ModelPERMFilingDataFilterInput
  $limit: Int
  $nextToken: String
) {
  listPERMFilingData(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      caseID
      PERMFirstPossibleFilingDate
      PERMLastPossibleFilingDate
      applicantsReceived
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPERMFilingDataQueryVariables,
  APITypes.ListPERMFilingDataQuery
>;
export const listCaseContributors = /* GraphQL */ `query ListCaseContributors(
  $filter: ModelCaseContributorFilterInput
  $limit: Int
  $nextToken: String
) {
  listCaseContributors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      caseID
      contributorID
      foreignNationalID
      state
      type
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCaseContributorsQueryVariables,
  APITypes.ListCaseContributorsQuery
>;
export const getTask = /* GraphQL */ `query GetTask($id: ID!) {
  getTask(id: $id) {
    id
    action
    isKeyDate
    keyDateAlternateAction
    isPaymentStatus
    paymentStatusAlternateAction
    assignedToID
    isAssignedToLegalAssistants
    assignedToEmployerID
    assignedToForeignNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    caseState
    category
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    comments {
      nextToken
      __typename
    }
    completeDate
    deadline
    deadlineIsManuallySet
    deleteDate
    deleteReason
    dependencies {
      nextToken
      __typename
    }
    description
    duration
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    groupsCanRead
    isCustom
    isManuallyUnlocked
    prerequisite {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    prerequisiteID
    startDate
    state
    templateID
    assigneeLowerName
    attorneyLowerFirstName
    attorneyLowerName
    paralegalLowerName
    paralegalLowerFirstName
    companyLowerName
    nationalLowerName
    orderIndex
    defaultAssignee
    createdAt
    updatedAt
    foreignNationalTasksId
    employerTasksId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTaskQueryVariables, APITypes.GetTaskQuery>;
export const listTasks = /* GraphQL */ `query ListTasks(
  $filter: ModelTaskFilterInput
  $limit: Int
  $nextToken: String
) {
  listTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTasksQueryVariables, APITypes.ListTasksQuery>;
export const searchTasks = /* GraphQL */ `query SearchTasks(
  $filter: SearchableTaskFilterInput
  $sort: [SearchableTaskSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableTaskAggregationInput]
) {
  searchTasks(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchTasksQueryVariables,
  APITypes.SearchTasksQuery
>;
export const listTaskTemplatesByProcess = /* GraphQL */ `query ListTaskTemplatesByProcess(
  $process: VisaStatus!
  $sortDirection: ModelSortDirection
  $filter: ModelTaskTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  listTaskTemplatesByProcess(
    process: $process
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      defaultAssignee
      duration
      groupsCanRead
      lockedByDefault
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      description
      paymentStatusAlternateAction
      prerequisiteID
      process
      category
      hidden
      isManuallyUnlocked
      durationFromStartDate
      orderIndex
      startDate
      deadline
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskTemplatesByProcessQueryVariables,
  APITypes.ListTaskTemplatesByProcessQuery
>;
export const getFileData = /* GraphQL */ `query GetFileData($id: ID!) {
  getFileData(id: $id) {
    id
    expirationDate
    durationOfStatus
    fileName
    original {
      bucket
      region
      key
      level
      identityId
      __typename
    }
    fileType
    fileRequirement
    fileCategory
    contentType
    issueDate
    dueDate
    isFlattened
    processRequestID
    companyID
    ownerNationalID
    sourceID
    uploadDate
    uploaderID
    uploaderEmployerID
    uploaderForeignNationalID
    uploaderTeamMemberID
    uploaderForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    uploaderTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    uploaderEmployer {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    cases {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFileDataQueryVariables,
  APITypes.GetFileDataQuery
>;
export const listFileData = /* GraphQL */ `query ListFileData(
  $filter: ModelFileDataFilterInput
  $limit: Int
  $nextToken: String
) {
  listFileData(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFileDataQueryVariables,
  APITypes.ListFileDataQuery
>;
export const fileDataBySource = /* GraphQL */ `query FileDataBySource(
  $sourceID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFileDataFilterInput
  $limit: Int
  $nextToken: String
) {
  fileDataBySource(
    sourceID: $sourceID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FileDataBySourceQueryVariables,
  APITypes.FileDataBySourceQuery
>;
export const getCaseRfgp = /* GraphQL */ `query GetCaseRfgp($id: ID!) {
  getCaseRfgp(id: $id) {
    id
    caseID
    items {
      itemType
      id
      __typename
    }
    status
    jobID
    fileID
    file {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    usedFileIDs
    skipped {
      itemType
      id
      reason
      __typename
    }
    errorMessage
    generatedAt
    generatedByID
    generatedBy {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    updatedByID
    updatedBy {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCaseRfgpQueryVariables,
  APITypes.GetCaseRfgpQuery
>;
export const listCaseRfgps = /* GraphQL */ `query ListCaseRfgps(
  $filter: ModelCaseRfgpFilterInput
  $limit: Int
  $nextToken: String
) {
  listCaseRfgps(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      caseID
      status
      jobID
      fileID
      usedFileIDs
      errorMessage
      generatedAt
      generatedByID
      updatedByID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCaseRfgpsQueryVariables,
  APITypes.ListCaseRfgpsQuery
>;
export const getActivity = /* GraphQL */ `query GetActivity($id: ID!) {
  getActivity(id: $id) {
    id
    createdAt
    updatedAt
    activityType
    ipAddress
    fieldName
    updatedValue
    actorID
    actorEmployerID
    actorForeignNationalID
    actorTeamMemberID
    actorType
    actorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    actorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    actorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    directTargetID
    directTargetCaseID
    directTargetCompanyID
    directTargetEmployerID
    directTargetFileDataID
    directTargetForeignNationalID
    directTargetProcessRequestID
    directTargetTaskID
    directTargetTeamMemberID
    directTargetReportID
    targetString
    targetCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    targetCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    targetEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    targetFileData {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    targetForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    targetProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    targetTask {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    targetTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    targetReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    indirectTargetID
    indirectTargetCaseID
    indirectTargetCompanyID
    indirectTargetEmployerID
    indirectTargetForeignNationalID
    indirectTargetProcessRequestID
    indirectTargetTeamMemberID
    indirectTargetReportID
    indirectTargetString
    indirectTargetCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    indirectTargetCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    indirectTargetEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    indirectTargetForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    indirectTargetProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    indirectTargetTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    indirectTargetReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    ownerID
    ownerCaseID
    ownerCompanyID
    ownerEmployerID
    ownerFileDataID
    ownerForeignNationalID
    ownerProcessRequestID
    ownerTeamMemberID
    ownerReportID
    ownerCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    ownerCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    ownerEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    ownerFileData {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    ownerForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    ownerProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    ownerTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    ownerReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActivityQueryVariables,
  APITypes.GetActivityQuery
>;
export const listActivities = /* GraphQL */ `query ListActivities(
  $filter: ModelActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  listActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      updatedAt
      activityType
      ipAddress
      fieldName
      updatedValue
      actorID
      actorEmployerID
      actorForeignNationalID
      actorTeamMemberID
      actorType
      directTargetID
      directTargetCaseID
      directTargetCompanyID
      directTargetEmployerID
      directTargetFileDataID
      directTargetForeignNationalID
      directTargetProcessRequestID
      directTargetTaskID
      directTargetTeamMemberID
      directTargetReportID
      targetString
      indirectTargetID
      indirectTargetCaseID
      indirectTargetCompanyID
      indirectTargetEmployerID
      indirectTargetForeignNationalID
      indirectTargetProcessRequestID
      indirectTargetTeamMemberID
      indirectTargetReportID
      indirectTargetString
      ownerID
      ownerCaseID
      ownerCompanyID
      ownerEmployerID
      ownerFileDataID
      ownerForeignNationalID
      ownerProcessRequestID
      ownerTeamMemberID
      ownerReportID
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListActivitiesQueryVariables,
  APITypes.ListActivitiesQuery
>;
export const searchActivities = /* GraphQL */ `query SearchActivities(
  $filter: SearchableActivityFilterInput
  $sort: [SearchableActivitySortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableActivityAggregationInput]
) {
  searchActivities(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      createdAt
      updatedAt
      activityType
      ipAddress
      fieldName
      updatedValue
      actorID
      actorEmployerID
      actorForeignNationalID
      actorTeamMemberID
      actorType
      directTargetID
      directTargetCaseID
      directTargetCompanyID
      directTargetEmployerID
      directTargetFileDataID
      directTargetForeignNationalID
      directTargetProcessRequestID
      directTargetTaskID
      directTargetTeamMemberID
      directTargetReportID
      targetString
      indirectTargetID
      indirectTargetCaseID
      indirectTargetCompanyID
      indirectTargetEmployerID
      indirectTargetForeignNationalID
      indirectTargetProcessRequestID
      indirectTargetTeamMemberID
      indirectTargetReportID
      indirectTargetString
      ownerID
      ownerCaseID
      ownerCompanyID
      ownerEmployerID
      ownerFileDataID
      ownerForeignNationalID
      ownerProcessRequestID
      ownerTeamMemberID
      ownerReportID
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchActivitiesQueryVariables,
  APITypes.SearchActivitiesQuery
>;
export const getNotification = /* GraphQL */ `query GetNotification($id: ID!) {
  getNotification(id: $id) {
    id
    createdAt
    updatedAt
    personID
    activityID
    activity {
      id
      createdAt
      updatedAt
      activityType
      ipAddress
      fieldName
      updatedValue
      actorID
      actorEmployerID
      actorForeignNationalID
      actorTeamMemberID
      actorType
      directTargetID
      directTargetCaseID
      directTargetCompanyID
      directTargetEmployerID
      directTargetFileDataID
      directTargetForeignNationalID
      directTargetProcessRequestID
      directTargetTaskID
      directTargetTeamMemberID
      directTargetReportID
      targetString
      indirectTargetID
      indirectTargetCaseID
      indirectTargetCompanyID
      indirectTargetEmployerID
      indirectTargetForeignNationalID
      indirectTargetProcessRequestID
      indirectTargetTeamMemberID
      indirectTargetReportID
      indirectTargetString
      ownerID
      ownerCaseID
      ownerCompanyID
      ownerEmployerID
      ownerFileDataID
      ownerForeignNationalID
      ownerProcessRequestID
      ownerTeamMemberID
      ownerReportID
      __typename
    }
    read
    personNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    personEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    personTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationQueryVariables,
  APITypes.GetNotificationQuery
>;
export const listNotifications = /* GraphQL */ `query ListNotifications(
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      updatedAt
      personID
      activityID
      read
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsQueryVariables,
  APITypes.ListNotificationsQuery
>;
export const listNotificationsByPersonByRead = /* GraphQL */ `query ListNotificationsByPersonByRead(
  $personID: ID!
  $readCreatedAt: ModelNotificationByPersonByReadCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotificationsByPersonByRead(
    personID: $personID
    readCreatedAt: $readCreatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      updatedAt
      personID
      activityID
      read
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsByPersonByReadQueryVariables,
  APITypes.ListNotificationsByPersonByReadQuery
>;
export const listNotificationsByPersonAll = /* GraphQL */ `query ListNotificationsByPersonAll(
  $personID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotificationsByPersonAll(
    personID: $personID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      updatedAt
      personID
      activityID
      read
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsByPersonAllQueryVariables,
  APITypes.ListNotificationsByPersonAllQuery
>;
export const getAdditionalFields = /* GraphQL */ `query GetAdditionalFields($id: ID!) {
  getAdditionalFields(id: $id) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdditionalFieldsQueryVariables,
  APITypes.GetAdditionalFieldsQuery
>;
export const listAdditionalFields = /* GraphQL */ `query ListAdditionalFields(
  $filter: ModelAdditionalFieldsFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdditionalFields(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      caseID
      fields
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdditionalFieldsQueryVariables,
  APITypes.ListAdditionalFieldsQuery
>;
export const getCustomTemplate = /* GraphQL */ `query GetCustomTemplate($id: ID!) {
  getCustomTemplate(id: $id) {
    id
    teamMemberId
    teamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    employerID
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    reports {
      nextToken
      __typename
    }
    templateReports {
      nextToken
      __typename
    }
    accessibleIds
    editableIds
    name
    selectedFields
    includeFN
    individualFNCase
    includeCases
    numberOfFilters
    numberOfColumns
    type
    category
    isDeleted
    viewAccess
    editAccess
    accessibleCompanyIds
    companyIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomTemplateQueryVariables,
  APITypes.GetCustomTemplateQuery
>;
export const listCustomTemplate = /* GraphQL */ `query ListCustomTemplate(
  $filter: ModelCustomTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  listCustomTemplate(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomTemplateQueryVariables,
  APITypes.ListCustomTemplateQuery
>;
export const searchCustomTemplates = /* GraphQL */ `query SearchCustomTemplates(
  $filter: SearchableCustomTemplateFilterInput
  $sort: [SearchableCustomTemplateSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableCustomTemplateAggregationInput]
) {
  searchCustomTemplates(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchCustomTemplatesQueryVariables,
  APITypes.SearchCustomTemplatesQuery
>;
export const getReports = /* GraphQL */ `query GetReports($id: ID!) {
  getReports(id: $id) {
    id
    templateID
    template {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    customTemplate {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    reportEntries {
      nextToken
      __typename
    }
    companyIds
    accessibleIds
    editableIds
    viewAccess
    editAccess
    type
    name
    status
    numberOfFilters
    numberOfColumns
    fromTemplate
    totalCountCycle
    completedCountCycle
    isCurrent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReportsQueryVariables,
  APITypes.GetReportsQuery
>;
export const listReports = /* GraphQL */ `query ListReports(
  $filter: ModelReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReportsQueryVariables,
  APITypes.ListReportsQuery
>;
export const reportsByTemplateID = /* GraphQL */ `query ReportsByTemplateID(
  $templateID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReportFilterInput
  $limit: Int
  $nextToken: String
) {
  reportsByTemplateID(
    templateID: $templateID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReportsByTemplateIDQueryVariables,
  APITypes.ReportsByTemplateIDQuery
>;
export const searchReports = /* GraphQL */ `query SearchReports(
  $filter: SearchableReportFilterInput
  $sort: [SearchableReportSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableReportAggregationInput]
) {
  searchReports(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchReportsQueryVariables,
  APITypes.SearchReportsQuery
>;
export const getReportEntries = /* GraphQL */ `query GetReportEntries($id: ID!) {
  getReportEntries(id: $id) {
    id
    reportID
    report {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    fullname
    firstname
    lastname
    middlename
    archived
    email
    personalEmail
    birthDate
    numberOfDependents
    numberOfFamilyContacts
    displayCompanyName
    companyLegalName
    companyFullName
    sponsoringCompanyFullName
    companyDbaName
    immigrationCurrentStatus
    immigrationStatusExpiration
    birthCountryCode
    citizenshipCountry
    chargeabilityCountry
    passportExpirationDate
    nivMaxout
    visaExpDate
    hasApprovedI140
    petitionerI140
    employmentBasedCategory
    priorityDate
    fnJobTitle
    socCode
    caseSocCode
    fnSalary
    startDate
    fnWorkLocation
    addressPrimary
    addressSecondary
    usResidentialAddress
    lastProcessType
    currentProcessType
    lowerProcessType
    lastPhaseCompleted
    currentPhase
    capType
    eadExpDate
    I797ApprovalExpDate
    I94ExpDate
    I94DS
    greenCardExpDate
    prevailingWageExpDate
    citizenshipEligibilityDate
    rfeDueDate
    dolAuditDueDate
    pwdExpDate
    firstEntryUS
    taxTrackingF1J1
    agreementExpDate
    agreementEffectiveDate
    mswsowExpDate
    permDueDate
    lotterySelectionDueDate
    advancedParoleExpDate
    reEntryPermitExpDate
    certifiedLcaExpDate
    title
    notes
    DS2019ExpDate
    isRelative
    relativeIds
    nextPhase
    requestedProcessSubCategory
    fnNameSlug
    caseSlug
    companyNameSlug
    employerNameSlug
    inviteStatus
    passportNumber
    phoneNumber
    personalPhone
    faxNumber
    passportGender
    preferredMailingAddress
    onboardingSections
    lastEntryUS
    employeeId
    caseNumber
    requestedProcess
    attorneyID
    caseAttorney
    sponsoringEmployerID
    sponsoringNationalID
    caseSponsor
    caseSponsorId
    caseManagerID
    caseManager
    contributorIds
    caseContributors
    caseStartDate
    caseOpenDate
    caseSalary
    state
    workLocation
    keyFilingDates
    lcaFiled
    capGap
    visaAdditionalProcessing
    stemExtEligible
    educationEvaluationNeeded
    wageIssues
    selection
    caseNature
    registrationCompleted
    receiptNumber
    currentCaseStatusText
    modifiedDate
    incompleteUscisReceiptNumber
    caseStatusHistory
    companyAttorneys
    companyAttorneyIds
    companyParalegals
    companyParalegalIds
    companyTotalCases
    companyTotalOpenCases
    companyTotalClosedCases
    companyTotalCompletedCases
    companyNationalCount
    fullTimeEmployeesInUS
    partTimeEmployeesInUS
    companyActiveNationalCount
    grossRevenueForMostRecentFiscalYear
    netRevenueForMostRecentFiscalYear
    naicsCodeOfCompany
    typeOfBusiness
    fein
    yearCompanyWasFoundedInUS
    aosFilingEligible
    requiresMeetingReminder
    isParent
    isPartnerCompany
    companyWhitelistedDomains
    companyContactLabel
    annualMeetingDate
    emCompanyNames
    emCompanyNameSlugs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReportEntriesQueryVariables,
  APITypes.GetReportEntriesQuery
>;
export const listReportEntries = /* GraphQL */ `query ListReportEntries(
  $filter: ModelReportEntriesFilterInput
  $limit: Int
  $nextToken: String
) {
  listReportEntries(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      reportID
      companyID
      foreignNationalID
      fullname
      firstname
      lastname
      middlename
      archived
      email
      personalEmail
      birthDate
      numberOfDependents
      numberOfFamilyContacts
      displayCompanyName
      companyLegalName
      companyFullName
      sponsoringCompanyFullName
      companyDbaName
      immigrationCurrentStatus
      immigrationStatusExpiration
      birthCountryCode
      citizenshipCountry
      chargeabilityCountry
      passportExpirationDate
      nivMaxout
      visaExpDate
      hasApprovedI140
      petitionerI140
      employmentBasedCategory
      priorityDate
      fnJobTitle
      socCode
      caseSocCode
      fnSalary
      startDate
      fnWorkLocation
      addressPrimary
      addressSecondary
      usResidentialAddress
      lastProcessType
      currentProcessType
      lowerProcessType
      lastPhaseCompleted
      currentPhase
      capType
      eadExpDate
      I797ApprovalExpDate
      I94ExpDate
      I94DS
      greenCardExpDate
      prevailingWageExpDate
      citizenshipEligibilityDate
      rfeDueDate
      dolAuditDueDate
      pwdExpDate
      firstEntryUS
      taxTrackingF1J1
      agreementExpDate
      agreementEffectiveDate
      mswsowExpDate
      permDueDate
      lotterySelectionDueDate
      advancedParoleExpDate
      reEntryPermitExpDate
      certifiedLcaExpDate
      title
      notes
      DS2019ExpDate
      isRelative
      relativeIds
      nextPhase
      requestedProcessSubCategory
      fnNameSlug
      caseSlug
      companyNameSlug
      employerNameSlug
      inviteStatus
      passportNumber
      phoneNumber
      personalPhone
      faxNumber
      passportGender
      preferredMailingAddress
      onboardingSections
      lastEntryUS
      employeeId
      caseNumber
      requestedProcess
      attorneyID
      caseAttorney
      sponsoringEmployerID
      sponsoringNationalID
      caseSponsor
      caseSponsorId
      caseManagerID
      caseManager
      contributorIds
      caseContributors
      caseStartDate
      caseOpenDate
      caseSalary
      state
      workLocation
      keyFilingDates
      lcaFiled
      capGap
      visaAdditionalProcessing
      stemExtEligible
      educationEvaluationNeeded
      wageIssues
      selection
      caseNature
      registrationCompleted
      receiptNumber
      currentCaseStatusText
      modifiedDate
      incompleteUscisReceiptNumber
      caseStatusHistory
      companyAttorneys
      companyAttorneyIds
      companyParalegals
      companyParalegalIds
      companyTotalCases
      companyTotalOpenCases
      companyTotalClosedCases
      companyTotalCompletedCases
      companyNationalCount
      fullTimeEmployeesInUS
      partTimeEmployeesInUS
      companyActiveNationalCount
      grossRevenueForMostRecentFiscalYear
      netRevenueForMostRecentFiscalYear
      naicsCodeOfCompany
      typeOfBusiness
      fein
      yearCompanyWasFoundedInUS
      aosFilingEligible
      requiresMeetingReminder
      isParent
      isPartnerCompany
      companyWhitelistedDomains
      companyContactLabel
      annualMeetingDate
      emCompanyNames
      emCompanyNameSlugs
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReportEntriesQueryVariables,
  APITypes.ListReportEntriesQuery
>;
export const entriesByReportID = /* GraphQL */ `query EntriesByReportID(
  $reportID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReportEntriesFilterInput
  $limit: Int
  $nextToken: String
) {
  entriesByReportID(
    reportID: $reportID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      reportID
      companyID
      foreignNationalID
      fullname
      firstname
      lastname
      middlename
      archived
      email
      personalEmail
      birthDate
      numberOfDependents
      numberOfFamilyContacts
      displayCompanyName
      companyLegalName
      companyFullName
      sponsoringCompanyFullName
      companyDbaName
      immigrationCurrentStatus
      immigrationStatusExpiration
      birthCountryCode
      citizenshipCountry
      chargeabilityCountry
      passportExpirationDate
      nivMaxout
      visaExpDate
      hasApprovedI140
      petitionerI140
      employmentBasedCategory
      priorityDate
      fnJobTitle
      socCode
      caseSocCode
      fnSalary
      startDate
      fnWorkLocation
      addressPrimary
      addressSecondary
      usResidentialAddress
      lastProcessType
      currentProcessType
      lowerProcessType
      lastPhaseCompleted
      currentPhase
      capType
      eadExpDate
      I797ApprovalExpDate
      I94ExpDate
      I94DS
      greenCardExpDate
      prevailingWageExpDate
      citizenshipEligibilityDate
      rfeDueDate
      dolAuditDueDate
      pwdExpDate
      firstEntryUS
      taxTrackingF1J1
      agreementExpDate
      agreementEffectiveDate
      mswsowExpDate
      permDueDate
      lotterySelectionDueDate
      advancedParoleExpDate
      reEntryPermitExpDate
      certifiedLcaExpDate
      title
      notes
      DS2019ExpDate
      isRelative
      relativeIds
      nextPhase
      requestedProcessSubCategory
      fnNameSlug
      caseSlug
      companyNameSlug
      employerNameSlug
      inviteStatus
      passportNumber
      phoneNumber
      personalPhone
      faxNumber
      passportGender
      preferredMailingAddress
      onboardingSections
      lastEntryUS
      employeeId
      caseNumber
      requestedProcess
      attorneyID
      caseAttorney
      sponsoringEmployerID
      sponsoringNationalID
      caseSponsor
      caseSponsorId
      caseManagerID
      caseManager
      contributorIds
      caseContributors
      caseStartDate
      caseOpenDate
      caseSalary
      state
      workLocation
      keyFilingDates
      lcaFiled
      capGap
      visaAdditionalProcessing
      stemExtEligible
      educationEvaluationNeeded
      wageIssues
      selection
      caseNature
      registrationCompleted
      receiptNumber
      currentCaseStatusText
      modifiedDate
      incompleteUscisReceiptNumber
      caseStatusHistory
      companyAttorneys
      companyAttorneyIds
      companyParalegals
      companyParalegalIds
      companyTotalCases
      companyTotalOpenCases
      companyTotalClosedCases
      companyTotalCompletedCases
      companyNationalCount
      fullTimeEmployeesInUS
      partTimeEmployeesInUS
      companyActiveNationalCount
      grossRevenueForMostRecentFiscalYear
      netRevenueForMostRecentFiscalYear
      naicsCodeOfCompany
      typeOfBusiness
      fein
      yearCompanyWasFoundedInUS
      aosFilingEligible
      requiresMeetingReminder
      isParent
      isPartnerCompany
      companyWhitelistedDomains
      companyContactLabel
      annualMeetingDate
      emCompanyNames
      emCompanyNameSlugs
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EntriesByReportIDQueryVariables,
  APITypes.EntriesByReportIDQuery
>;
export const searchReportEntries = /* GraphQL */ `query SearchReportEntries(
  $filter: SearchableReportEntriesFilterInput
  $sort: [SearchableReportEntriesSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableReportEntriesAggregationInput]
) {
  searchReportEntries(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      reportID
      companyID
      foreignNationalID
      fullname
      firstname
      lastname
      middlename
      archived
      email
      personalEmail
      birthDate
      numberOfDependents
      numberOfFamilyContacts
      displayCompanyName
      companyLegalName
      companyFullName
      sponsoringCompanyFullName
      companyDbaName
      immigrationCurrentStatus
      immigrationStatusExpiration
      birthCountryCode
      citizenshipCountry
      chargeabilityCountry
      passportExpirationDate
      nivMaxout
      visaExpDate
      hasApprovedI140
      petitionerI140
      employmentBasedCategory
      priorityDate
      fnJobTitle
      socCode
      caseSocCode
      fnSalary
      startDate
      fnWorkLocation
      addressPrimary
      addressSecondary
      usResidentialAddress
      lastProcessType
      currentProcessType
      lowerProcessType
      lastPhaseCompleted
      currentPhase
      capType
      eadExpDate
      I797ApprovalExpDate
      I94ExpDate
      I94DS
      greenCardExpDate
      prevailingWageExpDate
      citizenshipEligibilityDate
      rfeDueDate
      dolAuditDueDate
      pwdExpDate
      firstEntryUS
      taxTrackingF1J1
      agreementExpDate
      agreementEffectiveDate
      mswsowExpDate
      permDueDate
      lotterySelectionDueDate
      advancedParoleExpDate
      reEntryPermitExpDate
      certifiedLcaExpDate
      title
      notes
      DS2019ExpDate
      isRelative
      relativeIds
      nextPhase
      requestedProcessSubCategory
      fnNameSlug
      caseSlug
      companyNameSlug
      employerNameSlug
      inviteStatus
      passportNumber
      phoneNumber
      personalPhone
      faxNumber
      passportGender
      preferredMailingAddress
      onboardingSections
      lastEntryUS
      employeeId
      caseNumber
      requestedProcess
      attorneyID
      caseAttorney
      sponsoringEmployerID
      sponsoringNationalID
      caseSponsor
      caseSponsorId
      caseManagerID
      caseManager
      contributorIds
      caseContributors
      caseStartDate
      caseOpenDate
      caseSalary
      state
      workLocation
      keyFilingDates
      lcaFiled
      capGap
      visaAdditionalProcessing
      stemExtEligible
      educationEvaluationNeeded
      wageIssues
      selection
      caseNature
      registrationCompleted
      receiptNumber
      currentCaseStatusText
      modifiedDate
      incompleteUscisReceiptNumber
      caseStatusHistory
      companyAttorneys
      companyAttorneyIds
      companyParalegals
      companyParalegalIds
      companyTotalCases
      companyTotalOpenCases
      companyTotalClosedCases
      companyTotalCompletedCases
      companyNationalCount
      fullTimeEmployeesInUS
      partTimeEmployeesInUS
      companyActiveNationalCount
      grossRevenueForMostRecentFiscalYear
      netRevenueForMostRecentFiscalYear
      naicsCodeOfCompany
      typeOfBusiness
      fein
      yearCompanyWasFoundedInUS
      aosFilingEligible
      requiresMeetingReminder
      isParent
      isPartnerCompany
      companyWhitelistedDomains
      companyContactLabel
      annualMeetingDate
      emCompanyNames
      emCompanyNameSlugs
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchReportEntriesQueryVariables,
  APITypes.SearchReportEntriesQuery
>;
export const getStandardTemplate = /* GraphQL */ `query GetStandardTemplate($id: ID!) {
  getStandardTemplate(id: $id) {
    id
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStandardTemplateQueryVariables,
  APITypes.GetStandardTemplateQuery
>;
export const listStandardTemplate = /* GraphQL */ `query ListStandardTemplate(
  $filter: ModelStandardTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  listStandardTemplate(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      fields
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStandardTemplateQueryVariables,
  APITypes.ListStandardTemplateQuery
>;
export const searchStandardTemplate = /* GraphQL */ `query SearchStandardTemplate(
  $filter: SearchableStandardTemplateFilterInput
  $sort: [SearchableStandardTemplateSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableStandardTemplateAggregationInput]
) {
  searchStandardTemplate(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      fields
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchStandardTemplateQueryVariables,
  APITypes.SearchStandardTemplateQuery
>;
export const getScheduler = /* GraphQL */ `query GetScheduler($id: ID!) {
  getScheduler(id: $id) {
    id
    name
    eventBridgeschedulerName
    eventBridgeSchedulerID
    description
    schedulerExpression
    endDate
    startTime
    frequencyNumber
    frequencyUnit
    startDate
    timeZone
    targetUrl
    entityID
    taskDefinitionID
    taskDefinition {
      id
      taskType
      payload
      recipientIDs
      companyIndividualIDs
      individualIDs
      companyIDs
      updatedAt
      createdAt
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSchedulerQueryVariables,
  APITypes.GetSchedulerQuery
>;
export const listSchedulers = /* GraphQL */ `query ListSchedulers(
  $filter: ModelSchedulerFilterInput
  $limit: Int
  $nextToken: String
) {
  listSchedulers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      eventBridgeschedulerName
      eventBridgeSchedulerID
      description
      schedulerExpression
      endDate
      startTime
      frequencyNumber
      frequencyUnit
      startDate
      timeZone
      targetUrl
      entityID
      taskDefinitionID
      updatedAt
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSchedulersQueryVariables,
  APITypes.ListSchedulersQuery
>;
export const searchSchedulers = /* GraphQL */ `query SearchSchedulers(
  $filter: SearchableSchedulerFilterInput
  $sort: [SearchableSchedulerSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableSchedulerAggregationInput]
) {
  searchSchedulers(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      name
      eventBridgeschedulerName
      eventBridgeSchedulerID
      description
      schedulerExpression
      endDate
      startTime
      frequencyNumber
      frequencyUnit
      startDate
      timeZone
      targetUrl
      entityID
      taskDefinitionID
      updatedAt
      createdAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchSchedulersQueryVariables,
  APITypes.SearchSchedulersQuery
>;
export const getVendor = /* GraphQL */ `query GetVendor($id: ID!) {
  getVendor(id: $id) {
    id
    name
    type
    location
    email
    lowerName
    processRequests {
      nextToken
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetVendorQueryVariables, APITypes.GetVendorQuery>;
export const listVendors = /* GraphQL */ `query ListVendors(
  $filter: ModelVendorFilterInput
  $limit: Int
  $nextToken: String
) {
  listVendors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      type
      location
      email
      lowerName
      updatedAt
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVendorsQueryVariables,
  APITypes.ListVendorsQuery
>;
export const searchVendors = /* GraphQL */ `query SearchVendors(
  $filter: SearchableVendorFilterInput
  $sort: [SearchableVendorSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableVendorAggregationInput]
) {
  searchVendors(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      name
      type
      location
      email
      lowerName
      updatedAt
      createdAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchVendorsQueryVariables,
  APITypes.SearchVendorsQuery
>;
export const getTaskDefinition = /* GraphQL */ `query GetTaskDefinition($id: ID!) {
  getTaskDefinition(id: $id) {
    id
    taskType
    scheduler {
      id
      name
      eventBridgeschedulerName
      eventBridgeSchedulerID
      description
      schedulerExpression
      endDate
      startTime
      frequencyNumber
      frequencyUnit
      startDate
      timeZone
      targetUrl
      entityID
      taskDefinitionID
      updatedAt
      createdAt
      __typename
    }
    payload
    recipientIDs
    companyIndividualIDs
    individualIDs
    companyIDs
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTaskDefinitionQueryVariables,
  APITypes.GetTaskDefinitionQuery
>;
export const listTaskDefinitions = /* GraphQL */ `query ListTaskDefinitions(
  $filter: ModelTaskDefinitionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTaskDefinitions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      taskType
      payload
      recipientIDs
      companyIndividualIDs
      individualIDs
      companyIDs
      updatedAt
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskDefinitionsQueryVariables,
  APITypes.ListTaskDefinitionsQuery
>;
